<template>
  <div class="layout">
    <div class="bannerImage">
        <img v-if="image" alt="Truecaller Header Image" class="headerImage" :src="image">
        <img v-else alt="Truecaller Header Image" class="headerImage" src="../assets/TrueCallerHeaderv0.2.png">
    </div>
  </div>
</template>

<script>
export default {
  props: {
        image:String
    },
};
</script>
<style scoped>

@media screen and (min-width: 768px) {
  .headerImage{
    object-fit:initial;
    width: 100%;
    position: relative;
    top: -37px
  }
}
@media only screen and (max-width: 600px) {
  .headerImage{
    object-fit:initial;
    width: 100%;
    top:45px;
  }
}
@media only screen and (min-width: 600px) {
  .headerImage{
    object-fit:initial;
    width: 100%;
    position: relative;
    top: -37px
  }
}
</style>
